module.exports = __webpack_public_path__ + "img/red_050.b8abe636.png";